<template>
  <div>
    <div class="Config_Con">
      <el-row>
        <el-col :span="4">
          <div class="tree">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-size:16px;color:#4a4b4e;">{{ $t('lang.ConfigSetting.GroupSelection') }}</span>
              </div>
              <div class="treegroupinglist">
                <el-input :placeholder="$t('lang.ConfigSetting.Searchgroup')" v-model.lazy="SeekGrouping" size="mini"
                  class="Seek-Input" :clearable="true">
                </el-input>
                <div class="groupTree infinite-list" :infinite-scroll-immediate="false" v-infinite-scroll="loadGroup">
                  <el-tree class="filter-tree" :data="Grouplist" :props="groupingProps" @node-click="handleNodeClick"
                    :highlight-current="true" :expand-on-click-node="false" accordion :load="loadNode" lazy
                    :filter-node-method="filterNode" ref="groupTrees">
                  </el-tree>
                </div>
              </div>
            </el-card>
            <br>
            <!-- 设备选择 -->
            <device :gid="gid" ref="device" @loadDevice="loadDevice" @GetdevicelistDidAndSn="GetdevicelistDidAndSn">
            </device>
          </div>
        </el-col>
        <el-col :span="20" style="padding-left: 40px">
          <div class="tabs">
            <el-tabs @tab-click="GetTabs" type="border-card" v-model="TabsDefault">
              <el-tab-pane :label="$t('lang.wire.wireNetwork')" name="wire" :lazy="true">
                <wire :deviceDid="deviceDid" :deviceSn="deviceSn" :deviceSoftwareVer="deviceSoftwareVer"
                  v-if="TabName === 'wire' && deviceDid">
                </wire>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.mobile.mobileNetwork')" name="mobileNetwork" :lazy="true"
                v-if="Wan3GSwitch || Wan3GTwoSwitch">
                <mobile-network :deviceDid="deviceDid" :deviceSn="deviceSn" :Wan3GSwitch="Wan3GSwitch"
                  :Wan3GTwoSwitch="Wan3GTwoSwitch" :deviceSoftwareVer="deviceSoftwareVer"
                  v-if="TabName === 'mobileNetwork' && deviceDid">
                </mobile-network>
              </el-tab-pane>
              <el-tab-pane label="WIFI" name="wifi" :lazy="true" v-if="WifiSwitch">
                <wifi :deviceDid="deviceDid" :deviceSn="deviceSn" :data="TabsList" @GetConfig="GetTabs"
                  v-if="TabName === 'wifi' && deviceDid"></wifi>
              </el-tab-pane>
              <el-tab-pane v-if="true" :label="$t('lang.particulars.networkMonitoring')" name="网络监控" :lazy="true">
                <NetworkMonitor v-if="TabName === '网络监控' && deviceDid" :deviceSn="deviceSn" :deviceDid="deviceDid">
                </NetworkMonitor>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.ConfigSetting.Ststem')" name="system" :lazy="true">
                <system :deviceDid="deviceDid" :deviceSn="deviceSn" :data="TabsList"
                  :deviceSoftwareVer="deviceSoftwareVer" v-if="TabName === 'system' && deviceDid"></system>
              </el-tab-pane>
              <!-- user_iscustomer2 系统管理员 -->
              <el-tab-pane :label="$t('lang.ConfigSetting.Administration')" name="dropbear" :lazy="true"
                v-if="user_iscustomer != 0">
                <management :deviceDid="deviceDid" :deviceSn="deviceSn" :data="TabsList"
                  :deviceSoftwareVer="deviceSoftwareVer" v-if="TabName === 'dropbear' && deviceDid"></management>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.ConfigSetting.Firewall')" name="Firewall" :lazy="true">
                <firewall :deviceDid="deviceDid" :deviceSn="deviceSn" :data="TabsList" @GetConfig="GetTabs"
                  :loading="loading" :redirectLength="redirectLength" v-if="TabName === 'Firewall' && deviceDid">
                </firewall>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.ConfigSetting.PortForwards')" name="port" :lazy="true">
                <port :deviceDid="deviceDid" :deviceSn="deviceSn" @GetConfig="GetTabs"
                  v-if="TabName === 'port' && deviceDid" :data="TabsList" :redirectLength="redirectLength"
                  :loading="loading"></port>
              </el-tab-pane>
              <el-tab-pane v-if="smartlinkSwitch" :label="$t('lang.ConfigSetting.Smartlink')" name="智慧物联" :lazy="true">
                <smart-link :deviceDid="deviceDid" :deviceSn="deviceSn" @GetConfig="GetTabs"
                  v-if="TabName === '智慧物联' && deviceDid" :data="TabsList" :linkOptions="linkOptions" :loading="loading"
                  :originalServer="originalServer" :noSname="noSname" :vendorName="vendorName"
                  :deviceSoftwareVer="deviceSoftwareVer"></smart-link>
              </el-tab-pane>
              <el-tab-pane v-if="smartnmsSwitch" :label="$t('lang.ConfigSetting.smartnms')" name="网管服务" :lazy="true">
                <!-- <smart-link
                  :deviceDid="deviceDid"
                  :deviceSn="deviceSn"
                  @GetConfig="GetTabs"
                  v-if="TabName==='网管服务' && deviceDid"
                  :data="TabsList"
                  :linkOptions="linkOptions"
                  :loading="loading"
                  :originalServer="originalServer"
                  :noSname="noSname"
                  :vendorName="vendorName"
                  :deviceSoftwareVer="deviceSoftwareVer"
                ></smart-link> -->
                <smart-nms :loading="loading" @GetConfig="GetTabs" :deviceSoftwareVer="deviceSoftwareVer"
                  :linkOptions="linkOptions" :originalServer="originalServer" :deviceDid="deviceDid" :data="TabsList"
                  :vendorName="vendorName" :noSname="noSname" :deviceSn="deviceSn"></smart-nms>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.ConfigSetting.filter')" name="Filter">
                <all-filter :deviceDid="deviceDid" :deviceSn="deviceSn" :data="TabsList"
                  v-if="TabName === 'Filter' && deviceDid">
                </all-filter>
              </el-tab-pane>
              <el-tab-pane v-if="M2MSwitch" :label="$t('lang.ConfigSetting.M2MPlatform')" name="m2m" :lazy="true">
                <m2m :deviceSoftwareVer="deviceSoftwareVer" :deviceDid="deviceDid" :deviceSn="deviceSn"
                  v-if="TabName === 'm2m' && deviceDid" :data="TabsList">
                </m2m>
              </el-tab-pane>
              <el-tab-pane :label="$t('lang.ConfigSetting.L2TP')" v-if="L2PT_PPTP" name="L2TP" :lazy="true">
                <l2tp :deviceDid="deviceDid" :deviceSn="deviceSn" v-if="TabName === 'L2TP' && deviceDid"
                  :data="TabsList">
                </l2tp>
              </el-tab-pane>
              <el-tab-pane v-if="L2PT_PPTP" :label="$t('lang.ConfigSetting.PPTP')" name="PPTP" :lazy="true">
                <pptp :deviceDid="deviceDid" :deviceSn="deviceSn" v-if="TabName === 'PPTP' && deviceDid"
                  :data="TabsList">
                </pptp>
              </el-tab-pane>
              <el-tab-pane v-if="portalSwitch" :label="$t('lang.ConfigSetting.PortalAuthentication')" name="门户认证"
                :lazy="true">
                <portal-authentication :deviceDid="deviceDid" :deviceSn="deviceSn"
                  v-if="TabName === '门户认证' && deviceDid" :data="TabsList"></portal-authentication>
              </el-tab-pane>
              <el-tab-pane v-if="openVPN" :label="$t('lang.particulars.openvpn')" name="openVPN" :lazy="true">
                <open-v-p-n :deviceSoftwareVer="deviceSoftwareVer" v-if="TabName === 'openVPN' && deviceDid"
                  :deviceSn="deviceSn" :deviceDid="deviceDid"></open-v-p-n>
              </el-tab-pane>
              <el-tab-pane v-if="repeater" :label="$t('lang.particulars.repeater')" name="中继器" :lazy="true">
                <Repeater v-if="TabName === '中继器' && deviceDid" :deviceSn="deviceSn" :deviceDid="deviceDid"></Repeater>
              </el-tab-pane>
              <el-tab-pane v-if="ioControl" :label="$t('lang.particulars.IOControl')" name="IO控制" :lazy="true">
                <IoControl v-if="TabName === 'IO控制' && deviceDid" :deviceSn="deviceSn" :deviceDid="deviceDid">
                </IoControl>
              </el-tab-pane>
              <el-tab-pane v-if="smartEle" label="智慧电梯" name="智慧电梯" :lazy="true">
                <SmartEle v-if="TabName === '智慧电梯' && deviceDid" :deviceSn="deviceSn" :deviceDid="deviceDid"></SmartEle>
              </el-tab-pane>
              <el-tab-pane v-if="smartSms" label="SMS短信" name="SMS短信" :lazy="true">
                <sms v-if="TabName === 'SMS短信'" :deviceSn="deviceSn" :deviceDid="deviceDid"></sms>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getGroupList, listConfig, GroupDevices, getAddLevel3Group, getGroupListPage, getDeviceMqttStatus } from "@/api/configurationlist";
import wire from "./components/wire/index"
import mobileNetwork from './components/mobileNetwork/index'
import system from "./components/system/index";
import qos from "./components/qos/index";
import firewall from "./components/Firewall/index";
import management from "./components/management/index";
import zhwl from "./components/zhwl/index";
import port from "./components/port/index";
import allFilter from './components/Filter/index'
import m2m from "./components/m2m/m2m";
import wifi from "./components/wifi/index";
import NetworkMonitor from './components/networkMonitor/index'
import l2tp from './components/L2TP/index'
import pptp from './components/PPTP/index'
import SmartLink from './components/SmartLink/index'
import smartNms from './components/smartNms/index'
import PortalAuthentication from './components/PortalAuthentication'
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { mapGetters } from "vuex";
import { cloneDeep } from 'lodash'
import OpenVPN from "./components/openVPN/index.vue";
import Repeater from "./components/Repeater/repeater.vue";
import IoControl from "./components/IoControl/index.vue";
import SmartEle from "./components/SmartEle/index.vue";
import sms from "./components/sms/index.vue";
import device from "./device.vue";
export default {
  name: 'Configurationlist',
  data() {
    return {
      model: false,
      //tree配置
      groupingProps: {
        //子节点字段名
        children: "groupList",
        label: "group_name"
      },
      //分组列表
      Grouplist: [],
      //是否为系统管理员标识
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      //分组下的在线设备
      devicelist: [],
      devicelistCopy: [],
      //设备did
      deviceDid: "",
      //设备SN
      deviceSn: "SS",
      // PPTP/L2TP显示控制
      L2PT_PPTP: true,
      //lan配置数据
      ConfigData: {},
      SeekGrouping: "",
      //当前选择tab内容数据
      TabsList: {},
      //当前选择tab
      TabName: "",
      //3Gwan配置开关
      Wan3GSwitch: false,
      //tabs默认显示
      TabsDefault: 'wire',
      //wifi配置开关
      WifiSwitch: false,
      //3Gwan2配置开关
      Wan3GTwoSwitch: false,
      // M2M配置开关
      M2MSwitch: false,
      // smartlink配置端口
      smartlinkSwitch: false,
      // 网管服务
      smartnmsSwitch: false,
      //openvpn配置开关
      openVPN: true,
      repeater: true,
      // 门户认证
      portalSwitch: false,
      tableList: [],
      // 上下行选项列表
      linkOptions: [],
      loading: true, //加载图标
      // 智慧物联高级配置原始数据
      originalServer: {},
      noSname: true,
      // 端口转发所有长度
      redirectLength: 0,
      ioControl: false,
      // 定制协议
      vendorName: '',
      // 设备软件版本
      deviceSoftwareVer: '',
      // 智慧电梯
      smartEle: false,
      // sms短信
      smartSms: false,
      offset: 1,
      limit: 40,
      queryGroupTimmer: null,
      isLoad: false,
      selectGroup: {},
      deviceMax: 1,
      gid: undefined
    };
  },
  components: {
    mobileNetwork,
    system,
    qos,
    firewall,
    management,
    zhwl,
    port,
    allFilter,
    m2m,
    wifi,
    l2tp,
    pptp,
    SmartLink,
    smartNms,
    PortalAuthentication,
    wire,
    OpenVPN,
    Repeater,
    IoControl,
    NetworkMonitor,
    SmartEle,
    sms,
    device,
  },
  mounted() {
    this.getGroupListPageMehtod()
  },
  methods: {
    loadGroup() {
      if (this.isLoad) return;
      this.offset += 1;
      this.getGroupListPageMehtod()
    },
    getGroupListPageMehtod() {
      getGroupListPage({
        pid: 0,
        offset: this.offset,
        limit: this.limit,
        gpname: this.SeekGrouping ? this.SeekGrouping : undefined
      }).then((res) => {
        if (this.Grouplist.length > 0) {
          // this.Grouplist = [...this.Grouplist, ...res.data.data.list]
          if (res.data.data.list.length == 0) {
            this.offset -= 1
          }
          this.Grouplist.push(...res.data.data.list)
        } else {
          this.Grouplist = res.data.data.list
        }
      })
    },
    //获取二三级分组
    loadNode(node, resolve) {
      getAddLevel3Group(node.data.group_id)
        .then((res) => {
          resolve(res.data.queryResult)
        })
    },
    //点击分组获取该分组下的设备
    handleNodeClick(data) {
      this.gid = data.group_id
      // this.selectGroup = data;
      // this.SeekGrouping = data.group_name
      // GroupDevices(data.group_id, 1, this.deviceParams.limit, this.deviceParams.offset,"").then((res) => {
      //   // this.devicelist = res.data.queryResult.map((item, index) => {
      //   //   return {
      //   //     ...item,
      //   //     label: item.deviceSn + ` (${item.deviceName ? item.deviceName : 'N/A'})`
      //   //   }
      //   // })
      //   this.devicelist = res.data.data.list;
      //   this.devicelistCopy = this.devicelist.sort((a, b) => a.deviceIsConnected - b.deviceIsConnected)
      //   this.deviceMax = Math.ceil(res.data.data.total / this.deviceParams.limit)
      // })
    },
    loadDevice() {
      if (this.deviceMax > this.deviceParams.offset) {
        this.deviceParams.offset += 1;
        this.handleNodeClick(this.selectGroup)
      } else {
        this.$refs.device.deviceDisabled = true
      }

    },
    //点击获取该设备的did与sn
    async GetdevicelistDidAndSn(data) {
      // const res = await getDeviceMqttStatus(data.deviceSn)
      // if (!res.data.online) {
      //   this.$message.error("设备MQTT不在线");
      //   this.deviceDid = "";
      //   this.deviceSn = "";
      //   this.deviceSoftwareVer = "";
      //   return
      // }
      this.deviceDid = data.deviceDid;
      this.deviceSn = data.deviceSn;
      this.deviceSoftwareVer = data.deviceSoftwareVer;

      //3Gwan1显示控制
      if (data.deviceSn.includes('SS') || data.deviceSn.includes('PS')) {
        this.Wan3GSwitch = false
      } else {
        this.Wan3GSwitch = true
      }
      let op = []
      if (this.deviceSoftwareVer >= "v2.7") {
        op = [
          {
            config: "ciot",
            section: "system",
            options: [
              { option: "hardware_class" },
              { option: "product_model" },
            ]
          },
          {
            config: "ciot",
            section: "network",
            options: [
              { option: "enable_wifi" },
            ]
          },
          {
            config: "ciot",
            section: "utils",
            options: [
              { option: "enable_m2m" },
              { option: "enable_smartlink" },
              { option: "enable_nodogsplash" },
              { option: "enable_smartnms" },
              { option: "enable_remote" },
              { option: "enable_smartele" },
              { option: "enable_smartsms" },
              { option: "enable_smartcat" },
            ]
          }
        ]
      } else {
        op = [
          {
            section: "initconfig",
            config: "system",
            options: [
              { option: "hardware_class" },
              { option: "enable_wifi" },
              { option: "enable_m2m" },
              { option: "enable_smartlink" },
              { option: "enable_nodogsplash" },
              { option: "enable_smartnms" },
              { option: "enable_remote" },
              { option: "product_model" },
              { option: "enable_smartele" },
              { option: "enable_smartele" },
              { option: "enable_smartsms" },
              { option: "enable_smartcat" },
            ]
          },
        ]
      }
      listConfig(this.deviceSn, this.deviceDid, [
        ...op
      ]).then((res) => {
        let options = {}
        if (this.deviceSoftwareVer >= "v2.7") {
          options = {
            ...res.data.data.mess[0].s_objects[0].options,
            ...res.data.data.mess[1].s_objects[0].options,
            ...res.data.data.mess[2].s_objects[0].options
          }
        } else {
          options = res.data.data.mess[0].s_objects[0].options
        }
        //判断io是否显示
        if (options.product_model.indexOf("IR4") != -1 || options.product_model.indexOf("IG2") != -1 || options.product_model.indexOf("ZP4") != -1) {
          this.ioControl = true
        } else {
          this.ioControl = false
        }
        //3Gwan2显示控制
        if (options.hardware_class == 'DMDC') {//双模 smdc  单模
          this.Wan3GTwoSwitch = true
        } else {
          this.Wan3GTwoSwitch = false
        }
        //wifi显示控制
        if (options.enable_wifi == '1') {
          this.WifiSwitch = true
        } else {
          this.WifiSwitch = false
        }
        //M2M显示控制
        if (options.enableM2M == '0') {
          this.M2MSwitch = false
        } else {
          this.M2MSwitch = true
        }
        //smartlink显示控制
        if (options.enableSmartlink == '0') {
          this.smartlinkSwitch = false
        } else {
          this.smartlinkSwitch = true
        }
        if (options.enable_smartnms != '1') {
          this.smartnmsSwitch = false
        } else {
          this.smartnmsSwitch = true
        }
        // L2TP/PPTP显示控制,enable_remote == 1，打印服务器设备不显示，其他显示
        if (options.enable_remote == 1 || data.deviceSn.includes('PS')) {
          this.L2PT_PPTP = false
        } else {
          this.L2PT_PPTP = true
        }
        //门户认证显示控制
        if (options.enableNodogsplash && options.enableNodogsplash == 1) {
          this.portalSwitch = true
        } else {
          this.portalSwitch = false
        }
        // smartele显示控制
        if (options.enable_smartele && options.enable_smartele == 1) {
          this.smartEle = true
        } else {
          this.smartEle = false
        }
        if (options.enable_smartsms && options.enable_smartsms == 1) {
          this.smartSms = true
        } else {
          this.smartSms = false
        }
        // 中继器
        if (options.enable_smartcat && options.enable_smartcat == 1) {
          this.repeater = true
        } else {
          this.repeater = false
        }
      })
    },
    GetTabs(tab) {
      //获取当前选择tab
      this.TabName = tab.name;
      if (!this.deviceDid || !this.deviceSn) {
        this.$message({
          showClose: true,
          message: this.$t("lang.DateSelect.message2"),
          type: "warning"
        });
        return false;
      }
      // 清除之前的请求
      this.$store.dispatch('clearToken')
      this.GetTabsData();
    },
    //获取tab配置数据
    GetTabsData(TabsName = this.TabName) {
      this.TabsList = {};
      switch (TabsName) {
        //qos 暂未使用
        case "QoS": {
          listConfig(this.deviceSn, this.deviceDid, [
            {
              section: "qos",
              config: "qos",
              options: [
                { option: "interface" },
                { option: "classgroup" },
                { option: "enabled" },
                { option: "upload" },
                { option: "download" }
              ]
            }
          ])
            .then(res => {
            })
            .catch(err => {
              this.$message({
                message: this.$t('lang.request.timeout'),
                type: "warning"
              });
            });
          return;
        }
        case "智慧物联": {
          this.TabsList = { mode: [], COM: [], Conn: [], service: {} }
          this.linkOptions = []
          this.loading = true

          listConfig(this.deviceSn, this.deviceDid, [
            {
              section: 'conn',
              config: 'smartlink',
              options: [
                { option: 'name' },
                { option: 'proto' },
                { option: 'proto_mbtcp' },
                { option: 'enable_hbt' },
                { option: 'status' },
                { option: 'mode_name' },
                { option: 'listen_port' },
                { option: 'mode' },
                { option: 'enabled' },
                { option: 'conn_num' },
                { option: 'dev_name' },
                { option: 'hbt_interval' },
                { option: 'hbt_data' },
                { option: 'msg_prefix' },
                { option: 'msg_len_size' },
                { option: 'msg_seq_size' },
                { option: 'msg_crc_type' },
                { option: 'msg_suffix' },
                { option: 'dtu_svr_name' },
                { option: 'dtu_id' },
                { option: 'firm_code' },
                { option: 'dev_type' },
                { option: 'dev_key' },
                { option: 'gps_lng' },
                { option: 'gps_lat' },
                { option: 'key_date' },
                { option: 'dev_prefix' },
                { option: 'did' },
                { option: 'msg_dev_id' },
                { option: 'slave_id' },
                { option: 'rsp_timeout' },
                { option: 'modbus_debug' },
                { option: 'byte_timeout' },
                { option: 'proto_mbrtu' },
                { option: 'slave_port' },
                { option: 'username' },
                { option: 'password' },
                { option: 'topic_sub' },
                { option: 'topic_pub' },
                { option: 'mqtt_qos' },
                { option: 'mqtt_cid' },
                { option: 'mqtt_alive' },
                { option: 'msg_rep_conn' },
                { option: 'sync_local_data' },
                { option: 'resend_times' },
                { option: 'proto_mbascii' },
                { option: 'enable_daq' },
                { option: 'daq_interval' },
                { option: 'cmd_interval' },
                { option: 'auto_report' },
                { option: 'report_condition' },
                { option: 'report_interval' },
                { option: 'interval' },
                { option: 'offline_data' },
                { option: 'msg_upload_dev_id' },
                { option: 'local_port' },
                { option: 'sync_snmp_data' },
                { option: 'sub_device_id' },
                { option: 'custom_cmd' },
                { option: 'cmd_period' },
                { option: 'url' },
                { option: 'method' },
                { option: 'header' },
                { option: 's7_rack' },
                { option: 's7_slot' },
                { option: 'recv_timeout' },
              ],
              lists: [{ list: 'server' }, { list: 'slave_addr' }, { list: 'blockchain_ip' }]
            },
            {
              section: "mode",
              config: "smartlink",
              options: [
                { option: "enabled" }
              ],
              lists: [{ list: 'uplink' }, { list: 'downlink' }]
            },
            // 先从设备端获取产品型号
            (this.deviceSoftwareVer < 'v2.7' ? {
              section: 'initconfig',
              config: 'system',
              options: [
                { option: 'product_model' },
                { option: 'vendor_name' }
              ]
            } : {
              section: 'system',
              config: 'ciot',
              options: [
                { option: 'product_model' },
                { option: 'vendor_name' }
              ]
            }),
            {
              section: "service",
              config: "smartlink",
              options: [
                //        高级配置
                { option: "enabled" },
                { option: "enable_debug" },
                { option: "tcp_keepalive_time" },
                { option: "tcp_keepalive_interval" },
                { option: "tcp_keepalive_probes" },
                { option: "log_file_num" },
                { option: "log_file_size" },
                { option: "log_priority" }
              ]
            }
          ]).then((res) => {
            let Mode = res.data.data
            // 获取产品型号，根据产品型号判断有几个串口配置
            let product_model = ''
            // 连接配置
            let connLists = []
            // lists
            let lists = []
            // 串口
            let Com = []
            // 模板配置
            let mode = []
            if (Mode.mess) {
              Mode.mess.forEach((item, index) => {
                if (this.deviceSoftwareVer >= 'v2.7') {
                  if (item.section === 'system') {
                    product_model = item.s_objects[0].options.product_model
                    this.vendorName = item.s_objects[0].options.vendor_name
                  }
                } else {
                  if (item.section === 'initconfig') {
                    product_model = item.s_objects[0].options.product_model
                    this.vendorName = item.s_objects[0].options.vendor_name
                  }
                }
                if (item.section === 'conn') {
                  item.s_objects.forEach((connEle, index) => {
                    connLists.push({
                      options: { ...connEle.options, enable_daq: connEle.options.enable_daq === '1', auto_report: connEle.options.auto_report === '1' },
                      section: item.section,
                      lists: connEle.lists,
                      sname: connEle.sname
                    })
                    this.linkOptions.push({
                      label: connEle.options.name,
                      value: connEle.sname ? connEle.sname : connEle.options.name
                    })
                  })
                } else if (item.section === 'mode') {
                  mode = item.s_objects
                  item.s_objects.forEach((modeEle, index) => {
                    lists.push(modeEle.lists)
                  })
                } else if (item.section === 'service') {
                  this.TabsList.service = item.s_objects[0].options
                }
              })
            }
            let Conn = []
            // 用来去设备端获取上下行设备对应的数据
            let ConnObj = []
            lists.forEach((item, index) => {
              let concatUplink = []
              let concatDownlink = []
              concatUplink = Conn.concat(item.uplink)
              concatDownlink = Conn.concat(item.downlink)
              let concatArray = concatUplink.concat(concatDownlink)
              Conn = concatArray
            })
            Conn = Array.from(new Set(Conn))
            Conn.forEach(item => {
              ConnObj.push({
                section: item,
                config: 'smartlink',
                options: [
                  { option: 'name' },
                  { option: 'proto' },
                  { option: 'enable_hbt' },
                  { option: 'status' },
                  { option: 'mode_name' },
                  { option: 'listen_port' },
                  { option: 'mode' },
                  { option: 'enabled' },
                  { option: 'conn_num' },
                  { option: 'listen_port' }
                ],
              })
            })
            // 获取串口个数 SSnxxx 表示有n个串口（COM1 - COMn），如SS1521有1个串口；其他产品型号都是1个
            if (product_model.match('SS')) {
              // 分割获取串口个数
              let SS = product_model.split('SS')
              // 串口个数
              let num = parseInt((SS[1])[0])
              for (let i = 1; i <= num; i++) {
                Com.push(
                  {
                    section: `COM${i}`,
                    config: "smartlink",
                    options: [
                      //      串口配置
                      { option: "baudrate" },
                      { option: "data_bits" },
                      { option: "stop_bits" },
                      { option: "parity" },
                      { option: "flow_ctrl" },
                      { option: "timeout" },
                      { option: "frame_len" },
                      { option: "enable_frame" }
                    ]
                  }
                )
              }
            } else {
              Com.push(
                {
                  section: `COM1`,
                  config: "smartlink",
                  options: [
                    //      串口配置
                    { option: "baudrate" },
                    { option: "data_bits" },
                    { option: "stop_bits" },
                    { option: "parity" },
                    { option: "flow_ctrl" },
                    { option: "timeout" },
                    { option: "frame_len" },
                    { option: "enable_frame" }
                  ]
                }
              )
            }
            listConfig(this.deviceSn, this.deviceDid, [
              // 连接配置
              ...ConnObj,
              // 串口配置
              ...Com,
            ]).then(res => {
              let data = res.data.data
              if (data.mess) {
                lists.forEach((item, index) => {
                  let uplinkArr = []
                  let downlinkArr = []
                  item.uplink.forEach((uplinkItem, uplinkIndex) => {
                    uplinkArr.push()
                    data.mess.forEach((ele, eleIndex) => {
                      if (uplinkItem === ele.section) {
                        if (ele.s_objects.length > 0) {
                          uplinkArr.push(ele.s_objects[0].options.name)
                        }
                      }
                    })
                  })
                  item.downlink.forEach((downlinkItem, downlinkIndex) => {
                    data.mess.forEach((ele, eleIndex) => {
                      if (downlinkItem === ele.section) {
                        if (ele.s_objects.length > 0) {
                          downlinkArr.push(ele.s_objects[0].options.name)
                        } else {
                          // this.$set(mode[index], 'downlink', '')
                        }
                      }
                    })
                  })
                  this.$set(mode[index], 'uplink', uplinkArr)
                  this.$set(mode[index], 'downlink', downlinkArr)
                })
                data.mess.forEach(ele => {
                  if (ele.section.match('COM')) {
                    this.TabsList.COM.push({
                      ...(ele.s_objects[0].options),
                      section: ele.section
                    })
                  }
                })
                mode.forEach(item => {
                  this.TabsList.mode.push({
                    ...item.options,
                    uplink: item.uplink,
                    downlink: item.downlink
                  })
                })
                this.TabsList.Conn = connLists
              }
              if (this.TabsList.Conn.length > 0) {
                if (this.TabsList.Conn[0].sname) {
                  this.noSname = false
                } else {
                  this.noSname = true
                }
              } else {
                this.noSname = false
              }
              this.originalServer = cloneDeep(this.TabsList.service)
              this.linkOptions.push({ label: this.$t('lang.ConfigSetting.custom'), value: "--自定义--" })
              this.loading = false
            }).catch(err => {
              this.$message({
                message: this.$t('lang.request.timeout'),
                type: "warning"
              })
            })
          })
          break;
        }
        case "网管服务": {
          this.TabsList = { mode: [], COM: [], Conn: [], service: {} }
          this.linkOptions = []
          this.loading = true

          listConfig(this.deviceSn, this.deviceDid, [
            {
              section: 'conn',
              config: 'smartnms',
              options: [
                { option: 'name' },
                { option: 'proto' },
                { option: 'proto_mbtcp' },
                { option: 'enable_hbt' },
                { option: 'status' },
                { option: 'mode_name' },
                { option: 'listen_port' },
                { option: 'mode' },
                { option: 'enabled' },
                { option: 'conn_num' },
                { option: 'dev_name' },
                { option: 'hbt_interval' },
                { option: 'hbt_data' },
                { option: 'msg_prefix' },
                { option: 'msg_len_size' },
                { option: 'msg_seq_size' },
                { option: 'msg_crc_type' },
                { option: 'msg_suffix' },
                { option: 'dtu_svr_name' },
                { option: 'dtu_id' },
                { option: 'firm_code' },
                { option: 'dev_type' },
                { option: 'dev_key' },
                { option: 'gps_lng' },
                { option: 'gps_lat' },
                { option: 'key_date' },
                { option: 'dev_prefix' },
                { option: 'msg_dev_id' },
                { option: 'slave_id' },
                { option: 'rsp_timeout' },
                { option: 'modbus_debug' },
                { option: 'byte_timeout' },
                { option: 'proto_mbrtu' },
                { option: 'slave_port' },
                { option: 'username' },
                { option: 'password' },
                { option: 'topic_sub' },
                { option: 'topic_pub' },
                { option: 'mqtt_qos' },
                { option: 'mqtt_cid' },
                { option: 'mqtt_alive' },
                { option: 'msg_rep_conn' },
                { option: 'instance_id' },
                { option: 'product_key' },
                { option: 'device_name' },
                { option: 'device_secret' },
                { option: 'upload_inter' },
                { option: 'snmp_version' },
                { option: 'snmp_group_name' },
                { option: 'uds_server_path' },
                { option: 'aiot_server' },
                { option: 'security' },
              ],
              lists: [{ list: 'server' }, { list: 'slave_addr' }]
            },
            {
              section: "mode",
              config: "smartnms",
              options: [
                { option: "enabled" }
              ],
              lists: [{ list: 'uplink' }, { list: 'downlink' }]
            },
            // 先从设备端获取产品型号
            (this.deviceSoftwareVer < 'v2.7' ? {
              section: 'initconfig',
              config: 'system',
              options: [
                { option: 'product_model' },
                { option: 'vendor_name' }
              ]
            } : {
              section: 'system',
              config: 'ciot',
              options: [
                { option: 'product_model' },
                { option: 'vendor_name' }
              ]
            }),
            {
              section: "service",
              config: "smartnms",
              options: [
                //        高级配置
                { option: "enabled" },
                { option: "enable_debug" },
                { option: "tcp_keepalive_time" },
                { option: "tcp_keepalive_interval" },
                { option: "tcp_keepalive_probes" },
                { option: "log_file_num" },
                { option: "log_file_size" },
                { option: "log_priority" }
              ]
            }
          ]).then((res) => {
            let Mode = res.data.data
            // 获取产品型号，根据产品型号判断有几个串口配置
            let product_model = ''
            // 连接配置
            let connLists = []
            // lists
            let lists = []
            // 串口
            let Com = []
            // 模板配置
            let mode = []
            if (Mode.mess) {
              Mode.mess.forEach((item, index) => {
                if (this.deviceSoftwareVer >= 'v2.7') {
                  if (item.section === 'system') {
                    product_model = item.s_objects[0].options.product_model
                    this.vendorName = item.s_objects[0].options.vendor_name
                  }
                } else {
                  if (item.section === 'initconfig') {
                    product_model = item.s_objects[0].options.product_model
                    this.vendorName = item.s_objects[0].options.vendor_name
                  }
                }
                if (item.section === 'conn') {
                  item.s_objects.forEach((connEle, index) => {
                    connLists.push({
                      options: { ...connEle.options },
                      section: item.section,
                      lists: connEle.lists,
                      sname: connEle.sname
                    })
                    this.linkOptions.push({
                      label: connEle.options.name,
                      value: connEle.sname ? connEle.sname : connEle.options.name
                    })
                  })
                } else if (item.section === 'mode') {
                  mode = item.s_objects
                  item.s_objects.forEach((modeEle, index) => {
                    lists.push(modeEle.lists)
                  })
                } else if (item.section === 'service') {
                  this.TabsList.service = item.s_objects[0].options
                }
              })
            }
            let Conn = []
            // 用来去设备端获取上下行设备对应的数据
            let ConnObj = []
            lists.forEach((item, index) => {
              let concatUplink = []
              let concatDownlink = []
              concatUplink = Conn.concat(item.uplink)
              concatDownlink = Conn.concat(item.downlink)
              let concatArray = concatUplink.concat(concatDownlink)
              Conn = concatArray
            })
            Conn = Array.from(new Set(Conn))
            Conn.forEach(item => {
              ConnObj.push({
                section: item,
                config: 'smartnms',
                options: [
                  { option: 'name' },
                  { option: 'proto' },
                  { option: 'enable_hbt' },
                  { option: 'status' },
                  { option: 'mode_name' },
                  { option: 'listen_port' },
                  { option: 'mode' },
                  { option: 'enabled' },
                  { option: 'conn_num' },
                ],
              })
            })
            // 获取串口个数 SSnxxx 表示有n个串口（COM1 - COMn），如SS1521有1个串口；其他产品型号都是1个
            if (product_model.match('SS')) {
              // 分割获取串口个数
              let SS = product_model.split('SS')
              // 串口个数
              let num = parseInt((SS[1])[0])
              for (let i = 1; i <= num; i++) {
                Com.push(
                  {
                    section: `COM${i}`,
                    config: "smartnms",
                    options: [
                      //      串口配置
                      { option: "baudrate" },
                      { option: "data_bits" },
                      { option: "stop_bits" },
                      { option: "parity" },
                      { option: "flow_ctrl" },
                      { option: "timeout" },
                      { option: "frame_len" },
                      { option: "enable_frame" }
                    ]
                  }
                )
              }
            } else {
              Com.push(
                {
                  section: `COM1`,
                  config: "smartnms",
                  options: [
                    //      串口配置
                    { option: "baudrate" },
                    { option: "data_bits" },
                    { option: "stop_bits" },
                    { option: "parity" },
                    { option: "flow_ctrl" },
                    { option: "timeout" },
                    { option: "frame_len" },
                    { option: "enable_frame" }
                  ]
                }
              )
            }
            listConfig(this.deviceSn, this.deviceDid, [
              // 连接配置
              ...ConnObj,
              // 串口配置
              ...Com,
            ]).then(res => {
              let data = res.data.data
              if (data.mess) {
                lists.forEach((item, index) => {
                  let uplinkArr = []
                  let downlinkArr = []
                  item.uplink.forEach((uplinkItem, uplinkIndex) => {
                    uplinkArr.push()
                    data.mess.forEach((ele, eleIndex) => {
                      if (uplinkItem === ele.section) {
                        if (ele.s_objects.length > 0) {
                          uplinkArr.push(ele.s_objects[0].options.name)
                        }
                      }
                    })
                  })
                  item.downlink.forEach((downlinkItem, downlinkIndex) => {
                    data.mess.forEach((ele, eleIndex) => {
                      if (downlinkItem === ele.section) {
                        if (ele.s_objects.length > 0) {
                          downlinkArr.push(ele.s_objects[0].options.name)
                        } else {
                          // this.$set(mode[index], 'downlink', '')
                        }
                      }
                    })
                  })
                  this.$set(mode[index], 'uplink', uplinkArr)
                  this.$set(mode[index], 'downlink', downlinkArr)
                })
                data.mess.forEach(ele => {
                  // console.log(ele);
                  // if(ele.section.match('COM')) {
                  //     this.TabsList.COM.push({
                  //       ...(ele.s_objects[0].options),
                  //       section: ele.section
                  //     })
                  //   }
                })
                mode.forEach(item => {
                  this.TabsList.mode.push({
                    // ...item.options,
                    uplink: item.uplink,
                    downlink: item.downlink,
                    enabled: Mode.mess[1].s_objects[0].options.enabled
                  })
                })
                this.TabsList.Conn = connLists
              }
              if (this.TabsList.Conn.length > 0) {
                if (this.TabsList.Conn[0].sname) {
                  this.noSname = false
                } else {
                  this.noSname = true
                }
              } else {
                this.noSname = false
              }
              this.originalServer = cloneDeep(this.TabsList.service)
              this.linkOptions.push({ label: this.$t('lang.ConfigSetting.custom'), value: "--自定义--" })
              this.loading = false
            }).catch(err => {
              console.log(err);
              this.$message({
                message: this.$t('lang.request.timeout'),
                type: "warning"
              })
            })
          })
        }
      }
    },
    // 输入框搜索分组
    filterNode(value, data) {
      // 注意，测试平台数据混乱，个别分组名称为空，会引起报错，正式平台正常
      if (!value) {
        return true
      }
      return data.group_name && (data.group_name.toLowerCase()).includes(value.toLowerCase()) // 不区分大小写
    }
  },
  watch: {
    SeekGrouping(val) {
      this.isLoad = true;
      this.offset = 1
      if (!val) {
        this.Grouplist = []
        this.devicelistCopy = []
        this.$refs.device.devicelistCopy = []
        this.selectGroup = {}
        // this.deviceDisabled = true
        this.getGroupListPageMehtod()
      } else {
        if (this.queryGroupTimmer) {
          clearTimeout(this.queryGroupTimmer)
          this.queryGroupTimmer = null
          this.queryGroupTimmer = setTimeout(() => {
            this.queryGroupTimmer = null
            getGroupListPage({
              pid: 0,
              offset: 1,
              limit: 40,
              gpname: val
            }).then(res => {
              this.Grouplist = res.data.data.list
            })
          }, 500);
        } else {
          this.queryGroupTimmer = setTimeout(() => {
            this.queryGroupTimmer = null
            getGroupListPage({
              pid: 0,
              offset: 1,
              limit: 40,
              gpname: val
            }).then(res => {
              this.Grouplist = res.data.data.list
            })
          }, 500);
        }
      }

    },
    deviceSn(val) {
      if (val == '') {
        this.TabName = 'wire';
      } else {
        this.TabsDefault = 'wire'
        this.GetTabs({ name: this.TabsDefault })
      }
    },
    searchSN(val) {
      if (val) {
        let searchData = this.devicelist.filter((item, index) => {
          return item.deviceSn.includes(val.trim())
        })
        this.devicelistCopy = searchData
      } else {
        this.devicelistCopy = cloneDeep(this.devicelist)
      }
    }
  }
}
</script>
<style scoped>
.Config_Con {
  overflow: hidden;
}

.title {
  margin: 0.2rem 0rem;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
}

.tree {
  display: inline-block;
  width: 100%;
  margin-right: 100px;
}

.treegroupinglist {
  width: 100%;
  height: 30vh;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
}

.groupTree {
  overflow: scroll;
  height: 100%;
}

.filter-tree {
  height: 100%;
}

.devicelist {
  /* width: 100%;
  height: 300px;
  overflow: scroll; */
}

.Seek-Input {
  width: 80%;
  display: block;
  margin: 10px auto;
}
</style>
